export default "__VITE_ASSET__bbnMs7zl__"